import { defineComponent as t, renderSlot as r } from "vue";
const p = /* @__PURE__ */ t({
  inheritAttrs: !1,
  __name: "SortBy",
  props: {
    weight: {}
  },
  setup(o) {
    return (e, n) => r(e.$slots, "default");
  }
});
export {
  p as default
};
